// import Hecate from '@bybit/hecate';
import Cookie from 'js-cookie';

import { BYBIT_TOKEN_COOKIE_KEY, cookieDomain } from './constants';

const userProfile = (Hecate: any) => {
  Hecate.UserProfile.getUserProfile({
    needLogin: true,
    forceUpdate: true,
  }).then((res: any) => {
    const token = res.params ? res.params.userToken : '';
    if (token) {
      Cookie.set(BYBIT_TOKEN_COOKIE_KEY, token, {
        expires: 7,
        path: '/',
        domain: cookieDomain,
      });
    } else {
      Hecate.Router.pop();
    }
  });
};

const userInfoInit = async () => {
  const { default: Hecate } = await import('@bybit/hecate');
  console.log('Hecate', Hecate);
  await Hecate.ready();
  userProfile(Hecate);
};

export function initAppToken() {
  userInfoInit();
}
